"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DentalMonitoringIntegrationPatient_Factory = exports.Date_Factory = void 0;
var Date_Factory_1 = require("./Date_Factory");
Object.defineProperty(exports, "Date_Factory", { enumerable: true, get: function () { return Date_Factory_1.Date_Factory; } });
var DentalMonitoringIntegrationKey_1 = require("./DentalMonitoringIntegrationKey");
var DentalMonitoringPatientResponse_1 = require("./DentalMonitoringPatientResponse");
var Patient_1 = require("./Patient");
var DentalMonitoringIntegrationPatient_Factory = /** @class */ (function () {
    function DentalMonitoringIntegrationPatient_Factory() {
    }
    DentalMonitoringIntegrationPatient_Factory.CreateIncoming = function (model) {
        if (!model)
            return model;
        var result = {
            DentalMonitoringIntegrationKey: DentalMonitoringIntegrationKey_1.DentalMonitoringIntegrationKey_Factory.CreateIncoming(model.DentalMonitoringIntegrationKey),
            DentalMonitoringIntegrationKeyId: model.DentalMonitoringIntegrationKeyId,
            DM_NativeRecord: DentalMonitoringPatientResponse_1.DentalMonitoringPatientResponse_Factory.CreateIncoming(model.DM_NativeRecord),
            DM_PatientId: model.DM_PatientId,
            DM_ProfileId: model.DM_ProfileId,
            Patient: Patient_1.Patient_Factory.CreateIncoming(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateIncoming(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    DentalMonitoringIntegrationPatient_Factory.CreateOutgoing = function (model) {
        if (!model)
            return model;
        var result = {
            DentalMonitoringIntegrationKey: DentalMonitoringIntegrationKey_1.DentalMonitoringIntegrationKey_Factory.CreateOutgoing(model.DentalMonitoringIntegrationKey),
            DentalMonitoringIntegrationKeyId: model.DentalMonitoringIntegrationKeyId,
            DM_NativeRecord: DentalMonitoringPatientResponse_1.DentalMonitoringPatientResponse_Factory.CreateOutgoing(model.DM_NativeRecord),
            DM_PatientId: model.DM_PatientId,
            DM_ProfileId: model.DM_ProfileId,
            Patient: Patient_1.Patient_Factory.CreateOutgoing(model.Patient),
            PatientId: model.PatientId,
            RecordCreated: Date_Factory_1.Date_Factory.CreateOutgoing(model.RecordCreated),
            RecordId: model.RecordId,
            RecordStatus: model.RecordStatus,
        };
        return result;
    };
    return DentalMonitoringIntegrationPatient_Factory;
}());
exports.DentalMonitoringIntegrationPatient_Factory = DentalMonitoringIntegrationPatient_Factory;
